import { render, staticRenderFns } from "./billArticleComment.vue?vue&type=template&id=c78e540a&"
import script from "./billArticleComment.vue?vue&type=script&lang=js&"
export * from "./billArticleComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports